import React from 'react';

import fluidSizesSources from 'Components/Skeleton/fluidSizesSources';
import SkeletonImg from 'Components/Skeleton/SkeletonImg';
import SkeletonBundleLayout from 'Components/Skeleton/SkeletonBundleLayout';

// The cover's FluidImg in PickAndMixDesktopLayout and PickAndMixMobileLayout (the same in both): uncropped
const COVER_SIZES = '(min-width: 576px) 524px, calc(100vw - 1rem)';

/**
 * Pick and mix page while it loads: PickAndMixProductView's contrast background with its desktop layout on lg and
 * up and its mobile layout below (cover beside the tiers on md).
 * Slots: `name` (text), `cover` (image URL).
 */
export default function PickAndMixPageSkeleton() {
  return (
    <div className="PickAndMixPageSkeleton">
      <div className="PickAndMixPageSkeleton__contrast">
        <div className="PickAndMixPageSkeleton__slash" />
      </div>

      <SkeletonBundleLayout
        cover={<SkeletonImg slot="cover" sizes={COVER_SIZES} sources={fluidSizesSources(COVER_SIZES)} className="img-force-full" />}
      />
    </div>
  );
}
